import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { ModalAddExistingItem } from "./modal.js";

export function AddExistingItemModal({name, disabled}){
  const [show, setShow] = useState(false)
  return (
    <>
      <ModalAddExistingItem name={name} show={show} setShow={setShow}/>
      <Button disabled={disabled} onClick={()=>setShow(true)}>
        Add Existing 
      </Button>
    </>
  )



}